import { createSlice } from "@reduxjs/toolkit";

const initialQontakLogState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  qontakLogForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const qontakLogSlice = createSlice({
  name: "qontakLog",
  initialState: initialQontakLogState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    qontakLogFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    qontakLogAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    qontakLogCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.qontakLog.push(action.payload.qontakLog);
    },
    qontakLogDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.qontakLog.filter(
        (el) => el.follow_up_id !== action.payload.id,
      );
    },
    getQontakLog: (state, action) => {
      state.actionsLoading = false;
      state.qontakLogForEdit = action.payload.qontakLogForEdit;
      state.error = null;
    },
    // updateProduct
    qontakLogUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.qontakLog = state.entities.qontakLog.map((entity) => {
        if (entity.follow_up_id === action.payload.qontakLog.follow_up_id) {
          return action.payload.qontakLog;
        }
        return entity;
      });
    },
  },
});
